export enum CallActivitySubProcessPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    callActivitySubProcess = 'callActivitySubProcess',
    /**
     * 驳回规则
     */
    BackWardRule = 'BackWardRule',
    variableSettings = 'variableSettings',
     /**
     * 多实例设置
     */
    MultiInstanceLoopCharacteristics = 'MultiInstanceLoopCharacteristics',
}